import React from "react";
import { Dialog } from "primereact/dialog";
import AddingNewArea from "../add-area/add-areaPincode";
 
const AddArea = ({
  showAddUserModal,
  hideAddUserModal
}: any) => {
  return (
    <Dialog
      visible={showAddUserModal}
      className="quickview"
      breakpoints={{ "1400px": "45vw", "641px": "80vw" }}
      modal
      onHide={hideAddUserModal}
    >
      <AddingNewArea />
    </Dialog>
  );
};
 
export default AddArea;
 
 